import _get from 'lodash/get';
import { DURING_SALE, PRE_BUZZ } from '../components/common/PriceRevealPLPBanner/messages';

export function isMarketing(url) {
  if (url.toLowerCase().includes('gclid') || url.toLowerCase().includes('utm_')) {
    return true;
  }

  return false;
}

export const filterTrustmarkerImage = (image, index) => image.imageType === 'TRUST_MARKER';

export const getmaskedPrice = (amount, mask = 'X') => {
  let afterPoint = '';
  let price = amount.toString();
  if (price.indexOf('.') > 0) {
    afterPoint = price.substring(price.indexOf('.'), price.length);
  }
  price = Math.floor(0 + price);
  price = price.toString();
  let lastThree = price.substring(price.length - 3);
  const otherNumbers = price.substring(0, price.length - 3);
  if (otherNumbers != '') {
    lastThree = `,${lastThree}`;
  }
  const res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + afterPoint;

  return res.replace(/[0-9]/g, mask);
};

export const getFormattedPrice = (amount, showDecimal = true) => {
  let afterPoint = '';
  let price = amount.toString();
  if (price.indexOf('.') > 0) {
    afterPoint = price.substring(price.indexOf('.'), price.length);
  }
  price = Math.floor(0 + price);
  price = price.toString();
  let lastThree = price.substring(price.length - 3);
  const otherNumbers = price.substring(0, price.length - 3);
  if (otherNumbers != '') {
    lastThree = `,${lastThree}`;
  }
  let res;
  if (!showDecimal) {
    res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
  } else {
    res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + afterPoint;
  }
  return res;
};

export const getIsPriceRevealPDP = (
  priceRevealV2WebFeatureFlag,
  priceRevealV2WebData,
  productData,
  store,
  priceRevealLUXEFlag
) => {
  const { saleStartTime, saleEndTime } = productData || {};
  if (store === 'luxe') {
    if (
      priceRevealLUXEFlag &&
      priceRevealV2WebFeatureFlag &&
      priceRevealV2WebData?.priceRevealPDPFlag === 'ON' &&
      saleStartTime &&
      saleEndTime
    ) {
      return true;
    }
  } else if (
    priceRevealV2WebFeatureFlag &&
    priceRevealV2WebData?.priceRevealPDPFlag === 'ON' &&
    saleStartTime &&
    saleEndTime
  ) {
    return true;
  }
  return false;
};

export const getSaleDuration = (saleStartTime, saleEndTime) => {
  const currentTS = Date.now() / 1000;
  if (currentTS >= saleStartTime && currentTS < saleEndTime) {
    return DURING_SALE;
  }
  if (currentTS < saleStartTime) {
    return PRE_BUZZ;
  }
};

export const getShowPriceRevealOnSimilar = (saleStartTime, saleEndTime) => {
  if (getSaleDuration(saleStartTime, saleEndTime) === DURING_SALE) {
    return true;
  }
  if (localStorage.getItem('priceReveal_v2')) {
    return true;
  }

  return false;
};

export const getVolumeAndSizeFlag = colorVariant => {
  const attributes = _get(colorVariant, 'selected.attributes', []);
  const { selection1, selection2, classDesc, skuVisibleAttributes = '' } =
    attributes.reduce((acc, item) => ({ ...acc, [item.name]: item.value }), {}) || {};

  let appendDesc = false;
  let hideSizes = false;
  let metalPurity = false;
  let qualifierKey = 'size';
  let selectedMetalName = '';
  let qualifierKeysForDesc = [];

  if (selection1 || selection2) {
    // case when only volume is there no sizes so show volume in description
    appendDesc =
      // (selection1 === 'NULL' || !selection1) &&
      !!selection2 && selection2.toLowerCase() !== 'size';
    if (selection2 && selection2.toLowerCase() === 'null') appendDesc = false;
    if (appendDesc) qualifierKey = selection2;

    // case when only color are there no sizes so hide size select section
    hideSizes =
      (selection2 === 'NULL' || !selection2) &&
      !!selection1 &&
      selection1.toLowerCase() === 'color';

    metalPurity = !!selection1 && selection1.toLowerCase() === 'metalpurity';

    // need to optimize
    const selectedCode = _get(colorVariant, 'selected.code', '');
    colorVariant.options.forEach(color => {
      let colorSelected = false;
      if (color.code === selectedCode) {
        colorSelected = true;
      }
      color.variantOptionQualifiers.forEach((colorSwatch, j) => {
        if (metalPurity && colorSwatch.qualifier === 'metalPurity') {
          if (colorSelected) {
            selectedMetalName = colorSwatch.value || '';
          }
        }
      });
    });
    qualifierKeysForDesc = skuVisibleAttributes?.split(',');
  }

  const isThisJewelleryItem = classDesc === 'Fine Jewellery';

  return {
    hideSizes,
    appendDesc,
    metalPurity,
    qualifierKey,
    selectedMetalName,
    isThisJewelleryItem,
    qualifierKeysForDesc
  };
};
